/** Office Open XML xlsx MIME type. */
export const XLSX_MIME =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

// ASCII only; RFC 5987 `filename*=UTF-8''...` is out of scope (no backend emits it).
const CONTENT_DISPOSITION_FILENAME_RE = /filename="?([^";]+)"?/i;

/** Parse the `filename="..."` segment from a `Content-Disposition` header. */
export function parseContentDispositionFilename(
    header: string | undefined
): string | undefined {
    if (!header) return undefined;
    const match = CONTENT_DISPOSITION_FILENAME_RE.exec(header);
    return match?.[1];
}

/**
 * Trigger a browser-side file download for `blob`.
 *
 * Pass `XLSX_MIME` (or another type) when the blob's own `type` is
 * empty or wrong and needs to be forced for the save dialog.
 */
export function downloadBlob(
    blob: Blob,
    filename: string,
    mimeType?: string
): void {
    // Only re-wrap when forcing a different MIME; new Blob([blob]) copies bytes.
    const urlSource =
        mimeType && blob.type !== mimeType
            ? new Blob([blob], { type: mimeType })
            : blob;
    const url = window.URL.createObjectURL(urlSource);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    // Revoke after click; some engines invalidate the URL before
    // navigation latches if revoked first, silently failing the save.
    window.URL.revokeObjectURL(url);
}
